// ================================
// Custom.js for Twisted Flames
// ================================

// ==== TF Arrow Killer (put at TOP of custom.js) ====
// Removes overlay arrows and blocks any CSS pseudo-element arrows on product pages.
(function () {
  function killArrows(root) {
    // 1) Remove any real elements (your old JS arrows + theme slider buttons)
    (root || document).querySelectorAll(
      // your custom arrows
      '.pp-swipe-arrow, [data-pp-swipe-arrow],' +
      // theme slider buttons inside the main product gallery
      '[id^="MainProduct-"] .slider-button'
    ).forEach(el => el.remove());

    // 2) One-time CSS override for pseudo-element arrows (::before/::after)
    if (!document.getElementById('tf-kill-arrows')) {
      const style = document.createElement('style');
      style.id = 'tf-kill-arrows';
      style.textContent = `
        /* Scope to product pages only */
        body.template-product [id^="MainProduct-"] .thumbnail-list__wrapper::before,
        body.template-product [id^="MainProduct-"] .thumbnail-list__wrapper::after,
        body.template-product [id^="MainProduct-"] .thumbnail-slider::before,
        body.template-product [id^="MainProduct-"] .thumbnail-slider::after,
        body.template-product [id^="MainProduct-"] slider-component.thumbnail-slider::before,
        body.template-product [id^="MainProduct-"] slider-component.thumbnail-slider::after {
          content: none !important;
          background: none !important;
        }
      `;
      document.head.appendChild(style);
    }
  }

  // Run now, on section loads, and on dynamic re-renders
  document.addEventListener('DOMContentLoaded', () => killArrows(document));
  document.addEventListener('shopify:section:load', (e) => killArrows(e.target || document));
  new MutationObserver(() => killArrows(document)).observe(document.documentElement, {
    childList: true, subtree: true
  });
})();

// ----------------------
// Desktop thumbnail hover (works on product pages + homepage featured)
// ----------------------
document.addEventListener('DOMContentLoaded', function () {
  const desktopThumbnails = document.querySelectorAll(
    '.product__media-list [data-thumbnail]'
  );
  const desktopMainImage = document.querySelector(
    '.product__media-item[data-main-image]'
  );

  if (desktopThumbnails.length && desktopMainImage) {
    desktopThumbnails.forEach((thumb) => {
      thumb.addEventListener('mouseenter', function () {
        const mediaId = thumb.getAttribute('data-media-id');
        const target = document.querySelector(
          `.product__media-item[data-media-id="${mediaId}"]`
        );
        if (target) {
          desktopMainImage.classList.remove('is-active');
          target.classList.add('is-active');
        }
      });
    });
  }
});

// ----------------------
// Featured product — MOBILE thumbnails that scroll + swap main image
// ----------------------
document.addEventListener('DOMContentLoaded', function () {
  const mediaGallery = document.querySelector(
    '.featured-product .product__media-gallery'
  );

  if (mediaGallery && typeof mediaGallery.setActiveMedia === 'function') {
    const thumbs = document.querySelectorAll(
      '.featured-product .thumbnail-list__item button'
    );

    thumbs.forEach((btn) => {
      btn.addEventListener('click', function () {
        const mediaId = btn.getAttribute('data-target');
        if (mediaId) {
          mediaGallery.setActiveMedia(mediaId);
        }
      });
    });
  }
});

// ----------------------
// Autoplay video in product gallery
// ----------------------
document.addEventListener('DOMContentLoaded', function () {
  const productMediaWrappers = document.querySelectorAll(
    '.product__media-wrapper'
  );

  productMediaWrappers.forEach((wrapper) => {
    const video = wrapper.querySelector('video');
    if (video) {
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.autoplay = true;
      video.loop = true;
      video.play().catch(() => {});
    }
  });
});

// ----------------------
// Autoplay video in featured product
// ----------------------
document.addEventListener('DOMContentLoaded', function () {
  const featuredVideos = document.querySelectorAll(
    '.featured-product video'
  );

  featuredVideos.forEach((video) => {
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.autoplay = true;
    video.loop = true;
    video.play().catch(() => {});
  });
});

/* ========== FIX: Product gallery thumbnails not clicking on desktop ========== */
/* Works with Dawn-style <media-gallery> + <slider-component> markup              */
/* Normalizes slide/thumb IDs and (re)binds thumbnail clicks per gallery        */

(() => {
  const DEBUG = false;

  const log = (...args) => { if (DEBUG) console.debug('[gallery-fix]', ...args); };

  function normalizeId(raw, sectionId) {
    if (!raw) return null;
    const s = String(raw).trim();
    // If already prefixed correctly, keep it.
    if (s.startsWith(sectionId + '-')) return s;
    // Sometimes section id is duplicated, or weird characters sneak in. Clean both sides.
    const cleaned = s.replace(/[^A-Za-z0-9_-]/g, '');
    const cleanedSection = sectionId.replace(/[^A-Za-z0-9_-]/g, '');
    return `${cleanedSection}-${cleaned}`;
  }

  function getSectionIdFromMediaGallery(el) {
    // id="MediaGallery-<sectionId>"
    const id = el?.id || '';
    const m = id.match(/^MediaGallery-(.+)$/);
    return m ? m[1] : null;
  }

  function ensureViewerId(galleryEl, sectionId) {
    const desired = `GalleryViewer-${sectionId}`;
    // The viewer is a <slider-component id="GalleryViewer-SECTION">
    let viewer = galleryEl.querySelector(`#${CSS.escape(desired)}`);
    if (!viewer) {
      // Try to find any viewer then fix its id.
      const anyViewer = galleryEl.querySelector('slider-component[id^="GalleryViewer-"]');
      if (anyViewer) {
        anyViewer.id = desired;
        viewer = anyViewer;
      }
    }
    return viewer;
  }

  function normalizeGalleryIds(galleryEl) {
    const sectionId = getSectionIdFromMediaGallery(galleryEl);
    if (!sectionId) return { sectionId: null, viewer: null };

    const viewer = ensureViewerId(galleryEl, sectionId);

    // Slides
    galleryEl.querySelectorAll('.product__media-item').forEach(li => {
      const curr = li.dataset.mediaId || '';
      const normalized = normalizeId(curr || li.id?.split('-').slice(-1)[0], sectionId);
      if (normalized && curr !== normalized) {
        log('Fix slide data-media-id:', { from: curr, to: normalized });
        li.dataset.mediaId = normalized;
      }
      // Keep DOM id consistent if it looks like Slide-<section>-<mediaId>
      if (li.id && li.id.startsWith('Slide-')) {
        const parts = li.id.split('-');
        const suffix = normalized?.split('-').slice(1).join('-'); // media id portion
        const desiredId = `Slide-${sectionId}-${suffix}`;
        if (suffix && li.id !== desiredId) {
          li.id = desiredId;
        }
      }
    });

    // Thumbnails
    galleryEl.querySelectorAll('.thumbnail-list__item').forEach(li => {
      const curr = li.dataset.target || '';
      const normalized = normalizeId(curr, sectionId);
      if (normalized && curr !== normalized) {
        log('Fix thumb data-target:', { from: curr, to: normalized });
        li.dataset.target = normalized;
      }

      // Fix aria-controls on the button to match viewer id
      const btn = li.querySelector('button.thumbnail');
      if (btn) {
        const desiredControls = `GalleryViewer-${sectionId}`;
        if (btn.getAttribute('aria-controls') !== desiredControls) {
          btn.setAttribute('aria-controls', desiredControls);
        }
      }
    });

    return { sectionId, viewer };
  }

  function bindThumbClicks(galleryEl) {
    // Avoid double-binding
    if (galleryEl.__thumbsBound) return;
    galleryEl.__thumbsBound = true;

    const list = galleryEl.querySelector('.thumbnail-list');
    if (!list) return;

    list.addEventListener('click', (e) => {
      const btn = e.target.closest('button.thumbnail');
      if (!btn) return;

      const li = btn.closest('.thumbnail-list__item');
      const target = li?.dataset.target;
      if (!target) return;

      const slides = [...galleryEl.querySelectorAll('.product__media-item')];
      let slide = galleryEl.querySelector(`.product__media-item[data-media-id="${CSS.escape(target)}"]`);

      // Fallbacks: try unprefixed/prefixed forms if needed
      if (!slide) {
        const sectionId = getSectionIdFromMediaGallery(galleryEl) || '';
        const unprefixed = target.replace(new RegExp('^' + sectionId + '-'), '');
        slide = galleryEl.querySelector(`.product__media-item[data-media-id="${CSS.escape(unprefixed)}"]`)
             || galleryEl.querySelector(`.product__media-item[id$="${CSS.escape(unprefixed)}"]`);
      }

      if (!slide) return;

      e.preventDefault();
      e.stopPropagation();

      // Scroll the viewer to that slide (works for Dawn’s slider)
      try {
        slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      } catch (_e) {
        // Very old browsers fallback
        const viewerList = galleryEl.querySelector('#Slider-Gallery-' + (getSectionIdFromMediaGallery(galleryEl) || ''));
        if (viewerList) viewerList.scrollLeft = slide.offsetLeft;
      }

      // Update visual "active" state + counter like the theme does
      galleryEl.querySelectorAll('.product__media-item.is-active').forEach(el => el.classList.remove('is-active'));
      slide.classList.add('is-active');

      const idx = slides.indexOf(slide);
      const counter = galleryEl.querySelector('.slider-counter--current');
      if (counter && idx >= 0) counter.textContent = String(idx + 1);

      // Update aria-current on thumbs
      galleryEl.querySelectorAll('.thumbnail[aria-current]').forEach(b => b.removeAttribute('aria-current'));
      btn.setAttribute('aria-current', 'true');
    }, true); // capture early to win over any broken handlers
  }

  function fixOneGallery(galleryEl) {
    const { sectionId } = normalizeGalleryIds(galleryEl);
    if (!sectionId) return;
    bindThumbClicks(galleryEl);
  }

  function fixAllGalleries(root = document) {
    root.querySelectorAll('media-gallery[id^="MediaGallery-"]').forEach(fixOneGallery);
  }

  // Initial run
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => fixAllGalleries());
  } else {
    fixAllGalleries();
  }

  // Handle Shopify section loads (Theme Editor / dynamic renders)
  document.addEventListener('shopify:section:load', (evt) => {
    const container = evt.target || evt.detail?.sectionElement || evt.currentTarget;
    if (container) fixAllGalleries(container);
  });

  // As a safety net, watch for new media-gallery elements being added
  const mo = new MutationObserver((muts) => {
    muts.forEach(m => {
      m.addedNodes && m.addedNodes.forEach(n => {
        if (n.nodeType === 1) {
          if (n.matches?.('media-gallery[id^="MediaGallery-"]')) fixOneGallery(n);
          else if (n.querySelector?.('media-gallery[id^="MediaGallery-"]')) fixAllGalleries(n);
        }
      });
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
